import { AnyAction } from 'redux';
import { CancelOrderDto, CreateOrderDto, GetOrderDto, GetOrderListDto } from 'src/dtos';
import { Order } from 'src/models';

import { OrderConstant } from '../constants/orders.constants';
import { FromTradingBlockServerEvent } from '../events/FromTradingBlockServerEvent';

import { createAction, State, Type } from './utils';

export const doGetOrderList = (payload: GetOrderListDto & { fetchAll?: boolean }): AnyAction =>
  createAction(State.actionRequested(Type.GET_ORDERS), {
    ...payload,
    queryParams: payload.queryParams ?? {
      take: OrderConstant.DEFAULT_TAKE_QUERY_PARAM,
      skip: OrderConstant.DEFAULT_SKIP_QUERY_PARAM,
    },
  });

export const doSucceededGetOrderList = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_ORDERS), payload);

export const doGetOrder = (payload: GetOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_ORDERS_ID), payload);

export const doSucceededGetOrder = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_ORDERS_ID), payload);

export const doCreateOrder = (payload: CreateOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.CREATE_ORDER), payload);

export const doSucceededCreateOrder = (payload?: Order): AnyAction =>
  createAction(State.actionSucceeded(Type.CREATE_ORDER), payload);

export const doFailedCreateOrder = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.CREATE_ORDER), payload);

export const doClearCreateOrder = (): AnyAction => createAction(State.actionCleared(Type.CREATE_ORDER));

export const doCancelOrder = (payload: CancelOrderDto): AnyAction =>
  createAction(State.actionRequested(Type.CANCEL_ORDER), payload);

export const doSucceededCancelOrder = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.CANCEL_ORDER), payload);

export const doClearCancelOrder = (): AnyAction => createAction(State.actionCleared(Type.CANCEL_ORDER));

export const updateOrderFromEvent = (payload: FromTradingBlockServerEvent.OrderUpdateEventPayload): AnyAction =>
  createAction(Type.UPDATE_ORDER_FROM_EVENT, payload);
